import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { partsNeededAPI, clientsAPI, serviceCallsAPI, messagesAPI } from '@shared/apiClient';
import { MESSAGE_UNREAD_KEY } from '@shared/messaging/queryKeys';

export const useBadgeCounts = () => {
  const { data: partsSummary } = useQuery(
    ['partsNeededSummary'],
    () => partsNeededAPI.getPartsNeededSummary(),
    { refetchInterval: 60000 }
  );

  const { data: pendingClientsData } = useQuery(
    ['pendingClients'],
    () => clientsAPI.getPendingClients(),
    { refetchInterval: 60000 }
  );

  const { data: toFinalizeData } = useQuery(
    ['toFinalizeCount'],
    () => serviceCallsAPI.getServiceCalls({
      status: 'completed',
      isFinalized: false,
      limit: 1,
      page: 1,
    }),
    { refetchInterval: 60000 }
  );

  const { data: backlogData } = useQuery(
    ['schedulingBacklogSummary'],
    () => serviceCallsAPI.getSchedulingBacklog(),
    { refetchInterval: 30000 }
  );

  const { data: unreadMessagesData } = useQuery(
    [MESSAGE_UNREAD_KEY],
    () => messagesAPI.getUnreadCount(),
    { refetchInterval: 60000 }
  );

  return useMemo(() => {
    const items = backlogData?.data?.items || [];
    const overdue = items.filter(
      (i) => i.source !== 'cspire'
        && i.subgroup !== 'cspire_unassigned'
        && (i.dueBucket === 'overdue' || i.subgroup === 'overdue')
    ).length;
    const unassigned = items.filter(
      (i) => !['assigned_undated'].includes(i.subgroup)
    ).length;

    return {
      parts: partsSummary?.data?.openCount ?? 0,
      pendingClients: pendingClientsData?.data?.clients?.length ?? 0,
      toFinalize: toFinalizeData?.data?.pagination?.total ?? 0,
      overdue,
      unassigned,
      messages: unreadMessagesData?.data?.unreadCount ?? 0,
    };
  }, [partsSummary, pendingClientsData, toFinalizeData, backlogData, unreadMessagesData]);
};
